/* eslint-disable */
import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from "./routes"; 
 
import NProgress from 'accessible-nprogress';
import "accessible-nprogress/dist/accessible-nprogress.css";
import { checkAuth, checkRight } from "../plugins/auth";
import { recordUserActivity } from "../plugins/activity/activity"; // <-- new import

Vue.use(VueRouter);

const router =  new VueRouter({mode:'history', routes, duplicateNavigationPolicy: 'ignore'});

router.beforeEach((to, from, next) => {
    if(!to.meta.print) {
        NProgress.start();
    }

    if(to.path != '/login' && to.meta.requiresAuth && !checkAuth()) {

        next({ path: '/login'});
 
        return;
     }
 
     if(to.path != '/login') {
 
         if(!to.meta.permissions) { 
             next();
             NProgress.done();

             return;
         }
 
         checkRight(to.meta.permissions).then(() => {
             next();
             NProgress.done();
         }).catch(() => {
             next({ path: '/access-denied'});
             NProgress.done();
         });
 
         return;
     }
 
     next();
});

router.afterEach((to, from) => {
    // Record navigation as user activity
    // recordUserActivity({
    //     path: to.path,
    //     name: to.name,
    //     from: from.path,
    //     timestamp: new Date().toISOString()
    // }); 
    var activity='Page Access : Path from: '+from.path+ ' To '+to.path;
    recordUserActivity(activity);

    NProgress.done();
});

export default router;